import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { confirm, Button, Spin, Tooltip } from 'src/common/';
import ColorPicker from '../ColorPicker';
import RenameSearchProfile from '../../../RenameSearchProfile';
import { SearchProfileColor } from 'src/helpers/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import modalStyles from 'src/common/Modal/index.module.scss';
import { useDeleteSearchProfile } from 'src/pages/TenderPage/DocumentSearch/hooks';

interface IProps {
  color: SearchProfileColor;
  id: string;
  title: string;
  loading: boolean;
}

export const ProfileHeader: FC<IProps> = props => {
  const { color, title, id: profileId, loading } = props;
  const { t } = useTranslation();

  const [deleteSearchProfile, { loading: deleteSearchProfileLoading }] = useDeleteSearchProfile();

  const removeSearchProfile = useCallback(() => {
    confirm.confirm({
      title: t('KeywordSearch.removeSearchProfileConfirmTitle'),
      content: t('KeywordSearch.removeSearchProfileConfirmQuestion'),
      okText: t('Common.delete'),
      cancelText: t('Common.cancel'),
      className: modalStyles.confirmModal,
      centered: true,
      transitionName: 'ant-fade',
      onOk() {
        deleteSearchProfile({ id: profileId, name: title });
      }
    });
  }, [t, profileId, title, deleteSearchProfile]);

  const isLoading = deleteSearchProfileLoading || loading;

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <ColorPicker color={color} profileId={profileId} />
        <RenameSearchProfile groupTitle={title} groupId={profileId} />
        {isLoading && <Spin className={styles.spin} size={'small'} />}
      </div>
      <Tooltip title={t('KeywordSearch.deleteSearchProfile')}>
        <Button type={'text'} onClick={removeSearchProfile} icon={<FontAwesomeIcon icon={faTimes} />} />
      </Tooltip>
    </div>
  );
};

export default ProfileHeader;
